<template>
  <div class="container">
    <span>wechat pay test</span>
    <div style="margin-top: 20px;">
      <label for="goodId">输入商品id：</label>
      <input type="text" name="goodId" v-model="goodId">
    </div>
    <div style="margin-top: 20px;">
      <label for="goodPrice">输入商品金额(单位: 分)：</label>
      <input type="text" name="goodPrice" v-model="goodPrice">
    </div>
    <div style="margin-top: 20px;">
      <button @click="handleStart">点击开始创建订单</button>
    </div>
  </div>
  
</template>

<script>
import * as testApi from '@/apiv4/test'

export default {
  name: 'WechatPay',
  data() {
    return {
      goodId: 2611, // wt2: 6249 dev: 2611 6788
      goodPrice: 12799, // FIXME: 金额必须和商品金额一致，不然创建订单会失败
    }
  },
  created() {
    console.log('wechatPay支付页测试')
  },
  methods: {
    async handleStart() {
      this.createOrder({
        good_id: this.goodId,
        good_quantity: 1,
        order_price: this.goodPrice,
        coupon_id: 0,
        note: '测试ilisten-h5微信支付',
      })
    },
    async createOrder(params) {
      this.$loading.show('生成订单中...')
      try {
        const { data } = await testApi.createOrder(params)
        console.log(data)
        // 支付订单
        setTimeout(() => {
          // this.$loading.hide()
          this.payOrder({
            order_id: +data.order.order_id,
            pay_way: 'weixin',
            note: '测试ilisten-h5微信支付',
            comefrom: 'web',
          })
        }, 1000)
      } catch (err) {
        console.error('创建订单失败', err)
        this.$loading.hide()
      }
    },
    async payOrder(params) {
      try {
        this.$loading.show('生成支付订单数据...')
        const { data } = await testApi.payOrder(params)
        console.log('生成支付订单数据', data)
        setTimeout(() => {
          this.$loading.show('正在跳转外部支付链接')
          setTimeout(() => {
            this.$loading.hide()
            const reg = /goodsDesc=(.+?)&/g
            const payUrl = data.url.replace(reg, (full, $1) => {
                return full.replace($1, encodeURIComponent(encodeURIComponent($1)))
            })
            const pos = 'out'
            const url = `ilisten:///webopen?title=&pos=${pos}&url=${encodeURIComponent(payUrl)}&login=&fullscreen=`
            console.log(payUrl)
            window.location.href = url
          }, 1000)
        }, 1000)
      } catch (err) {
        console.error('生成支付订单失败', err)
        this.$loading.hide()
      }
    }
  }
}
</script>

<style>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  /* line-height: 100vh; */
  text-align: center;
}
</style>
